module.exports = __webpack_public_path__ + "static/media/right-arrow.c1bd94d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/right-arrow.svg
// module id = 742
// module chunks = 0